import VueRouter, { Route } from 'vue-router';
import { VueConstructor } from 'vue';
import { CoreOptions } from '../../index';
import _ from '../../utils';
import RouterUtils from './routerUtils';
import RouterHistory from './history';

declare module 'vue/types/vue' {
  interface Vue {
    $routerUtils: RouterUtils
  }
  interface VueConstructor {
    $router: VueRouter
    $routerUtils: RouterUtils
  }
}
declare module 'vue-router' {
  export default interface VueRouter{
    history: RouterHistory,
  }
}

export default {
  install(Vue: VueConstructor, options: CoreOptions) {
    Vue.use(VueRouter);

    let router = options.router as VueRouter;
    if (!(router instanceof VueRouter)) {
      router = new VueRouter({
        ...options.router,
      });
    }
    Vue.$router = router;
    
    Vue.$routerUtils = new RouterUtils(Vue.$router);
    Vue.prototype.$routerUtils = Vue.$routerUtils;
  },
};
